import { useQuery } from "react-query";
import { getEmployeeReportsTo } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetEmployeeReportsToByOfficeCode = (officeCode) => {
  return useQuery(
    ["EmployeeReportsTo", officeCode],
    () => getEmployeeReportsTo(officeCode),
    { refetchOnWindowFocus: false }
  );
};
